module.exports = __webpack_public_path__ + "assets/fs-daifahuo.89c09cbc.svg";